import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';
import { getCheckboxesPercentagesRows } from '#models/general/fields/checkboxPercentage';

import { DISTILLATION_FIELDS, NEW_PRODUCT_SUBSTEPS_IDS } from './constants';
import { getOperatorsForStep } from './utils';

const OPERATORS = {
  MARK_GIESLER: 'markGiesler',
  GORDON_MACKENZIE: 'gordonMackenzie',
  ROSS_HUGHES: 'rossHughes',
  NICKY_DOCHERTY: 'nickyDocherty',
  CHRIS_ANDERSON: 'chrisAnderson',
  SCOTT_STEWART: 'scottStewart',
  STEWART_CONNOR: 'stewartConnor',
  ALASTAIR_MACKAY: 'alastairMackay',
  DJ_CAMERON: 'djCameron',
  ALLY_FISHER: 'allyFisher',
  LOUIS_MACKENZIE: 'louisMackenzie'
};

export const DISTILLED_BY_OPTIONS = getOperatorsForStep(OPERATORS, 'Distilled');

export const getDistillationFields = ({ values, errors }) => {
  const getDistillationValues = getSubStepValues(NEW_PRODUCT_SUBSTEPS_IDS.DISTILLATION, values, errors);
  return [
    ...getCheckboxesPercentagesRows(
      Object.values(DISTILLED_BY_OPTIONS),
      getDistillationValues,
      values,
      'Distilled'
    ),
    {
      ...getDistillationValues(DISTILLATION_FIELDS.MIN_HYDROMETER),
      Component: Input,
      noMargin: true
    },
    {
      ...getDistillationValues(DISTILLATION_FIELDS.MAX_HYDROMETER),
      Component: Input,
      noMargin: true
    }
  ];
};
